import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashImageComponent } from './smash-image/smash-image.component';
import { SharedModule } from '@app/shared/shared.module';



@NgModule({
  declarations: [
    SmashImageComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    SmashImageComponent
  ]
})
export class SmashImageModule { }
